import { StudentConstants as Constants } from '../types'
import { studentApi as api } from '../../api'

export const studentAction = {
    get,
    add,
    update,
    feeplan,
    remove,
    remove_doc,
    clear,
};

function get(offset, filters, size) {    
    return dispatch => {
        dispatch(loading())
        return new Promise((resolve, reject) => {
            api._get(offset, filters, size)
                .then(
                    payload => {
                        dispatch(success(payload));
                        resolve(payload)
                    },
                    error => {
                        dispatch(failure(error));
                        reject(error)
                    }
                )

        });
    }
    function success(payload) { return { type: Constants.GET, payload } }
    function loading() { return { type: Constants.LOADING } }
    function failure(error) { return { type: Constants.FAIL, error } }
}

function add(data) {
    return dispatch => {
        return new Promise((resolve, reject) => {
            api._add(data)
                .then(
                    payload => {
                        dispatch(success(payload));
                        resolve(payload)
                    },
                    error => {
                        dispatch(failure('Failed'));
                        reject(error)
                    }
                )

        });
    }
    function success(payload) { return { type: Constants.ADD, payload } }
    function failure(error) { return { type: Constants.FAIL, error } }
}

function update(data, id) {
    return dispatch => {
        return new Promise((resolve, reject) => {
            api._update(data,id)
                .then(
                    payload => {
                        dispatch(success(payload));
                        resolve()
                    },
                    error => {
                        dispatch(failure(error));
                        reject(error)
                    }
                )
        });
    function success(payload) { return { type: Constants.UPDATE, payload } }
    function failure(error) { return { type: Constants.FAIL, error } }
    }
}

function feeplan(data, id) {
    return dispatch => {
        return new Promise((resolve, reject) => {
            api._feeplan(data,id)
                .then(
                    payload => {
                        dispatch(success(payload));
                        resolve()
                    },
                    error => {
                        dispatch(failure(error));
                        reject(error)
                    }
                )
        });
    function success(payload) { return { type: Constants.UPDATE, payload } }
    function failure(error) { return { type: Constants.FAIL, error } }
    }
}

function remove(id) {
    return dispatch => {
        return new Promise((resolve, reject) => {
            api._delete(id)
                .then(
                    payload => {
                        dispatch(success(payload));
                        resolve()
                    },
                    error => {
                        dispatch(failure(error));
                        reject(error)
                    }
                )
        });
    function success(payload) { return { type: Constants.DELETE, payload } }
    function failure(error) { return { type: Constants.FAIL, error } }
    }
}

function remove_doc(id, doc_id) {
    return dispatch => {
        dispatch(success({id, doc_id}))        
        function success(payload) { return { type: Constants.REMOVE_DOC, payload } }    
    }
}

function clear() {
    return dispatch => {   
        return new Promise((resolve, reject) => {     
            dispatch(success());
            resolve()
        })   
    }
    function success() { return { type: Constants.CLEAR } }
}